import { z } from 'zod';
import { adminAuditFieldsSchema } from './IAdminAudit';

export const drinkSchema = adminAuditFieldsSchema.extend({
    id: z.number().default(-1),
    name: z.string().default(''),
    price: z.coerce.number().default(0.00),
    remarks: z.string().nullable().optional().default(''),
});

export type IDrink = z.infer<typeof drinkSchema>;
